import React, { useState, useEffect } from "react";
import api from "../api/axios";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const AddEditProductImage = () => {
   const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [products, setProduct] = useState([]);
  // product_list
  const product_image_detail = JSON.parse(
    localStorage.getItem("product-image-list")
  );
  const storedProductImageDetail = product_image_detail;
  const BASE_IMAGE_URL = `${BASE_URL}/`;
  const [initialImagePath, setInitialImagePath] = useState(null);
  const isEditMode = storedProductImageDetail?.product_image_id;
  const fetchProduct = async () => {
    try {
      const response = await api.post(`/product/get`);
      if (response.data.success) {
        setProduct(response.data.product);
      } else {
        // setError("Product not found");
      }
    } catch (err) {
      //   setError("Error fetching product details");
    } finally {
      //   setLoading(false);
    }
  };

  useEffect(() => {
    fetchProduct();
  }, []);

  useEffect(() => {
    // Check if data is available in localStorage
    if (
      storedProductImageDetail &&
      storedProductImageDetail?.product_image_id
    ) {
      // A. Pre-fill form state
      setFormData((prev) => ({
        ...prev,
        product_id: storedProductImageDetail.id || "",
        id: storedProductImageDetail.product_image_id || "",
        name: storedProductImageDetail.product_image_name || "",
        description: storedProductImageDetail?.product_description || "",
        // Initialize other fields if necessary
      }));

      // B. Set image preview
      if (storedProductImageDetail.image) {
        const fullPath = storedProductImageDetail.image.startsWith("http")
          ? storedProductImageDetail.image
          : `${BASE_IMAGE_URL}${storedProductImageDetail.image}`;

        setPreview(fullPath);
        setInitialImagePath(fullPath);
      }
    } else {
      // If data is NOT in localStorage or ID doesn't match, fetch from API
      setFormData([]);
    }
  }, [isEditMode]); // Dependencies

  const history = useHistory();
  const [formData, setFormData] = useState({
    product_id: "",
    name: "",
    description: "",
    image: "",
  });
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);

  // handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // handle image file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setImage(e.target.files[0]);
    if (file) {
      setPreview(URL.createObjectURL(file)); // create temporary image URL
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("product_id", formData.product_id);
    data.append("name", formData.name);
    data.append("description", formData?.description);
    if (image) {
      data.append("image", image);
    }
    try {
      let response;
      let url;
      let method; 

      if (isEditMode) {
        url = `/product_image/update/${isEditMode}`;
        method = api.post; 
      } else {
        url = "/product_image/create"; 
        method = api.post;
      }

      response = await method(url, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.success) {
        localStorage.removeItem("product-image-list");
        const successMessage = isEditMode
          ? "Product Image updated successfully!"
          : "Product Image added successfully!";
      
        toast.success(successMessage);
        history.push("/product-images");
      } else {
        toast.error("Submission failed: " + (response.data.message || "Unknown error."))
      }
    } catch (err) {
      console.error("Submission error:", err);
      const apiErrors = err.response?.data?.errors;
      if (apiErrors) {
         toast.error("Validation failed: " + Object.values(apiErrors).flat().join(" | "))
      } else {      
        toast.error("Error submitting product!");
      }
    }
  };
  return (
    <>
      <div className="main-content-inner">
        {/* <!-- main-content-wrap --> */}
        <div className="main-content-wrap">
          <div className="flex items-center flex-wrap justify-between gap20 mb-27">
            <h3>{isEditMode?" Edit Product":"Add Product"}</h3>
            <ul className="breadcrumbs flex items-center flex-wrap justify-start gap10">
              <li>
                <Link to="/">
                  <div className="text-tiny">Dashboard</div>
                </Link>
              </li>
              <li>
                <i className="icon-chevron-right"></i>
              </li>
              <li>
                <div className="text-tiny">{isEditMode? "Edit product Image":" Add product Image"}</div>
              </li>
            </ul>
          </div>
          {/* <!-- form-add-product --> */}
          <form
            className="tf-section-2 form-add-product"
            onSubmit={handleSubmit}
          >
            <div className="wg-box">
              <fieldset className="product_id">
                <div class="body-title mb-10"> Product Category Name </div>
                <div class="select">
                  <select
                    name="product_id"
                    id="product_id"
                    value={formData.product_id}
                    onChange={handleChange}
                  >
                    <option>Select Product Category</option>
                    {products.map((element) => {
                      return (
                        <option value={element.id}>{element?.name}</option>
                      );
                    })}
                  </select>
                </div>
              </fieldset>
              <fieldset className="name">
                <div className="body-title mb-10">
                  Name <span className="tf-color-1">*</span>
                </div>
                <input
                  className="mb-10"
                  type="text"
                  placeholder="Enter product name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </fieldset>

              <fieldset className="description">
                <div className="body-title mb-10">
                  Description
                </div>               
                <CKEditor
                  editor={ClassicEditor}
                  data={formData?.description || null}
                  onChange={(event, editor) => {
                    const data = editor?.getData();
                    setFormData((prev) => ({ ...prev, description: data }));
                  }}                 
                />
              </fieldset>
              <fieldset className="mt-4">
                <div className="body-title mb-10">Upload Image</div>

                <input
                  type="file"
                  id="myFile"
                  name="image"
                  onChange={handleFileChange}
                  accept="image/*"
                  className="block w-full text-sm text-gray-700 border border-gray-300 rounded-lg cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 p-2"
                />

                {preview && (
                  <div className="mt-4">
                    <img
                      src={preview}
                      alt="Preview"
                      className="w-32 h-32 object-cover rounded-lg border border-gray-300"
                    />
                  </div>
                )}
              </fieldset>

              <div className="cols gap10 mt-4">
                <button className="tf-button style-1 w-full" type="submit">
                  Save Product
                </button>
              </div>
            </div>
          </form>
          {/* <!-- /form-add-product --> */}
        </div>
        {/* <!-- /main-content-wrap --> */}
      </div>
    </>
  );
};
export default AddEditProductImage;
